import { BriefingOrganizeByApiEnum } from '../../../api/briefings/enum/briefing-organize-by-api.enum';

export enum BriefingOrganizeByEnum {
    MANUAL = 'MANUAL',
    SENTIMENT = 'SENTIMENT',
    MEDIA_TYPE = 'MEDIA_TYPE',
    TAGS = 'TAGS',
    FOLDERS = 'FOLDERS',
    ALL = 'ALL'
}

export const briefingOrganizeByMapFromApi = new Map<BriefingOrganizeByApiEnum, BriefingOrganizeByEnum>([
    [BriefingOrganizeByApiEnum.MANUAL, BriefingOrganizeByEnum.MANUAL],
    [BriefingOrganizeByApiEnum.SENTIMENT, BriefingOrganizeByEnum.SENTIMENT],
    [BriefingOrganizeByApiEnum.MEDIA_TYPE, BriefingOrganizeByEnum.MEDIA_TYPE],
    [BriefingOrganizeByApiEnum.TAGS, BriefingOrganizeByEnum.TAGS],
    [BriefingOrganizeByApiEnum.FOLDERS, BriefingOrganizeByEnum.FOLDERS],
    [BriefingOrganizeByApiEnum.ALL, BriefingOrganizeByEnum.ALL]
]);

export const briefingOrganizeByMapToApi = new Map<BriefingOrganizeByEnum, BriefingOrganizeByApiEnum>([
    [BriefingOrganizeByEnum.MANUAL, BriefingOrganizeByApiEnum.MANUAL],
    [BriefingOrganizeByEnum.SENTIMENT, BriefingOrganizeByApiEnum.SENTIMENT],
    [BriefingOrganizeByEnum.MEDIA_TYPE, BriefingOrganizeByApiEnum.MEDIA_TYPE],
    [BriefingOrganizeByEnum.TAGS, BriefingOrganizeByApiEnum.TAGS],
    [BriefingOrganizeByEnum.FOLDERS, BriefingOrganizeByApiEnum.FOLDERS],
    [BriefingOrganizeByEnum.ALL, BriefingOrganizeByApiEnum.ALL]
]);
